var React = require('react');

function ArrowIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M12 5.6C12.3314 5.6 12.6 5.33137 12.6 5C12.6 4.66863 12.3314 4.4 12 4.4V5.6ZM0.575736 4.57574C0.341421 4.81005 0.341421 5.18995 0.575736 5.42426L4.39411 9.24264C4.62843 9.47696 5.00833 9.47696 5.24264 9.24264C5.47696 9.00833 5.47696 8.62843 5.24264 8.39411L1.84853 5L5.24264 1.60589C5.47696 1.37157 5.47696 0.991674 5.24264 0.757359C5.00833 0.523045 4.62843 0.523045 4.39411 0.757359L0.575736 4.57574ZM12 4.4L1 4.4V5.6L12 5.6V4.4Z","fill":"#FFD07A"}));
}

ArrowIcon.defaultProps = {"width":"13","height":"10","viewBox":"0 0 13 10","fill":"none"};

module.exports = ArrowIcon;

ArrowIcon.default = ArrowIcon;
